<script setup lang="ts">
import { CalendarDays } from 'lucide-vue-next'

// Kinds of finance events; no dates or places so the picture never goes stale
const { t } = useI18n()

const events = [
  { key: 'fintech', tone: 'bg-blue-600' },
  { key: 'banking', tone: 'bg-yellow-400' },
  { key: 'investment', tone: 'bg-emerald-500' }
] as const
</script>

<template>
  <div class="relative w-[21rem] select-none" aria-hidden="true">
    <div class="HeroIllustrationCard">
      <div class="flex items-center gap-3">
        <span class="grid size-11 place-items-center rounded-xl bg-blue-600 text-white">
          <CalendarDays class="size-5" />
        </span>
        <div class="font-serif text-xl font-bold">{{ t('widget.hero_banner.illustration.events.upcoming') }}</div>
      </div>

      <ul class="mt-4 space-y-1.5">
        <li v-for="event in events" :key="event.key" class="flex items-center gap-3 rounded-xl bg-blue-50 px-3 py-2">
          <span class="h-8 w-1 rounded-full" :class="event.tone" />
          <span class="flex-1 text-sm font-semibold">{{ t(`widget.hero_banner.illustration.events.${event.key}`) }}</span>
        </li>
      </ul>
    </div>

    <div class="HeroIllustrationBadge -bottom-4 -left-8">
      {{ t('widget.hero_banner.illustration.events.registration') }}
    </div>
  </div>
</template>
